var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTouchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 39V13.5C24 12.3065 24.4741 11.1619 25.318 10.318C26.1619 9.47411 27.3065 9 28.5 9C29.6935 9 30.8381 9.47411 31.682 10.318C32.5259 11.1619 33 12.3065 33 13.5V36M33 34.5V28.5C33 27.3065 33.4741 26.1619 34.318 25.318C35.1619 24.4741 36.3065 24 37.5 24C38.6935 24 39.8381 24.4741 40.682 25.318C41.5259 26.1619 42 27.3065 42 28.5V36M42 31.5C42 30.3065 42.4741 29.1619 43.318 28.318C44.1619 27.4741 45.3065 27 46.5 27C47.6935 27 48.8381 27.4741 49.682 28.318C50.5259 29.1619 51 30.3065 51 31.5V36",
    stroke: "#F8F8F8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51 34.5C51 33.3065 51.4741 32.1619 52.318 31.318C53.1619 30.4741 54.3065 30 55.5 30C56.6935 30 57.8381 30.4741 58.682 31.318C59.5259 32.1619 60 33.3065 60 34.5V48C60 52.7739 58.1036 57.3523 54.7279 60.7279C51.3523 64.1036 46.7739 66 42 66H36H36.624C33.643 66.0005 30.7086 65.2606 28.0842 63.8469C25.4597 62.4331 23.2275 60.3896 21.588 57.9L21 57C20.064 55.564 16.778 49.836 11.142 39.816C10.5673 38.7946 10.4138 37.5893 10.7141 36.4565C11.0144 35.3236 11.7448 34.3526 12.75 33.75C13.8211 33.1091 15.0753 32.8438 16.3142 32.9959C17.5531 33.1481 18.7058 33.709 19.59 34.59L24 39M15 9L12 6M12 21H9M42 9L45 6M45 18H48",
    stroke: "#F8F8F8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTouchIcon);
export default __webpack_public_path__ + "static/media/touchIcon.2890e1d39179e01e5bd6f722dc5eb514.svg";
export { ForwardRef as ReactComponent };